export default __webpack_public_path__ + "static/img/20.c594de7.png";